import { createIngredientId } from '@libs/trip-planner-interfaces';
import type {
  IngredientId,
  IngredientType,
} from '@libs/trip-planner-interfaces';
import { DEFAULT_TRANSPORT_TYPE, uniqueIdGenerator } from '@libs/utils';
import type { ConnectionType } from '@libs/maps';

export abstract class BaseIngredient<T extends IngredientType> {
  public readonly ingredientId: IngredientId;
  public isNewIngredient = false;
  public transportTypeToBeReached: ConnectionType = DEFAULT_TRANSPORT_TYPE;

  constructor(public readonly ingredientType: T) {
    this.ingredientId = createIngredientId(uniqueIdGenerator());
  }

  public abstract isIngredientCorrect(): boolean;
}
